import { render, staticRenderFns } from "./OrderLogistics.vue?vue&type=template&id=611d9b4a&scoped=true"
import script from "./OrderLogistics.vue?vue&type=script&lang=js"
export * from "./OrderLogistics.vue?vue&type=script&lang=js"
import style0 from "./OrderLogistics.vue?vue&type=style&index=0&id=611d9b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611d9b4a",
  null
  
)

export default component.exports